export default __webpack_public_path__ + "static/media/automatskavrata12.c973e5f5.jpg";